import React from "react";

function ShipIcon(
    { title = "ship-icon", titleId = "ship-icon-1", ...props },
    svgRef
) {
    return /*#__PURE__*/ React.createElement(
        "svg",
        Object.assign(
            {
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                "aria-hidden": "true",
                "data-slot": "icon",
                ref: svgRef,
                "aria-labelledby": titleId,
            },
            props
        ),
        title
            ? /*#__PURE__*/ React.createElement(
                  "title",
                  {
                      id: titleId,
                  },
                  title
              )
            : null,
        /*#__PURE__*/ React.createElement("path", {
            d: "M21.7777 12.4515C21.682 12.182 21.453 12.0225 21.2135 11.9147L19.7218 11.3268V5.51533C19.7218 5.27707 19.6272 5.04857 19.4587 4.8801C19.2902 4.71163 19.0617 4.61698 18.8235 4.61698H15.4097V3.17962C15.4097 2.98901 15.334 2.80621 15.1992 2.67143C15.0645 2.53666 14.8817 2.46094 14.6911 2.46094H8.94162C8.75101 2.46094 8.56821 2.53666 8.43343 2.67143C8.29866 2.80621 8.22294 2.98901 8.22294 3.17962V4.61698H4.8092C4.57095 4.61698 4.34245 4.71163 4.17397 4.8801C4.0055 5.04857 3.91085 5.27707 3.91085 5.51533V11.3304L2.42498 11.917C2.18557 12.0248 1.94975 12.1865 1.85363 12.456C1.75751 12.7255 1.71169 12.9865 1.80871 13.3094L4.10175 20.0551H4.14936C5.68195 20.0551 7.02409 19.2731 7.98128 18.0869C8.93892 19.2731 10.2802 19.9788 11.8127 19.9788C13.3453 19.9788 14.6875 19.2709 15.6447 18.0846C16.6023 19.2709 17.9435 20.0551 19.4761 20.0551H19.5237L21.8258 13.3099C21.9228 13.0404 21.8738 12.7215 21.7777 12.4515ZM11.8163 8.21038L5.34821 10.763V6.23401C5.34821 6.18636 5.36714 6.14066 5.40084 6.10697C5.43453 6.07327 5.48023 6.05434 5.52788 6.05434H18.1048C18.1524 6.05434 18.1981 6.07327 18.2318 6.10697C18.2655 6.14066 18.2845 6.18636 18.2845 6.23401V10.7599L11.8163 8.21038Z",
        }),
        /*#__PURE__*/ React.createElement("path", {
            d: "M15.825 19.6641C13.4781 21.2928 10.1497 21.2923 7.80275 19.6641C7.80275 19.6641 5.75272 22.4939 3.55176 22.4939L4.15051 22.5388C5.49175 22.5388 6.78492 22.0119 7.98242 21.3893C9.16632 22.0031 10.4803 22.3235 11.8139 22.3235C13.1474 22.3235 14.4615 22.0031 15.6454 21.3893C16.8429 22.0124 18.136 22.5392 19.4773 22.5392L20.076 22.4943C17.9357 22.4939 15.825 19.6641 15.825 19.6641Z",
        })
    );
}
const ForwardRef = React.forwardRef(ShipIcon);

export default ForwardRef;
